import { render } from "./index.vue?vue&type=template&id=7a180cc5&scoped=true&bindings={}"
import script from "./Loading.js?vue&type=script&lang=js"
export * from "./Loading.js?vue&type=script&lang=js"

import "./Loading.scss?vue&type=style&index=0&id=7a180cc5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a180cc5"

export default script